import { connect } from 'react-redux';
import PostShiftComponent from './PostShiftComponent';
import { requestsOperations } from '../Requests/duck';
import { withRouter } from 'react-router'; // 👈 import this
const mapStateToProps = ({ appReducer, setupReducer, locationReducer}) => {
  const unsortedChannels = appReducer.channels.data.map((element) => ({
    text: element.channel_name,
    value: element.id,
    type: element.channel_type,
    member_count: element.member_count,
  }));

  const channels = [
    unsortedChannels.filter((channel) => channel.type === 'location_feed')[0],
    ...unsortedChannels.filter((channel) => channel.type !== 'location_feed'),
  ];

  const channelsLoading = appReducer.channels.loading;
  const vtoEnabled = setupReducer.setup_actions?.meta?.current_location?.cfg_vto || false;
  const postOpenShiftEnabled =
    appReducer.location.settings.cfg__shift__post_open_shift;
  const locationId = locationReducer.location_code;
  const costCenterData = appReducer.location.costCenterData;
  const skills = appReducer.skills.data;
  const locationSettings = appReducer.location.settings;
  const userPrivileges = appReducer.users.data;
  const channelMembers = appReducer.users.data;
  const actionMenuEnabled = appReducer.location.settings.cfg__action_menu;
  const originalChannels = appReducer.channels.data;

  return {
    channels,
    vtoEnabled,
    postOpenShiftEnabled,
    channelsLoading,
    costCenterData,
    locationId,
    skills,
    locationSettings,
    userPrivileges,
    channelMembers,
    actionMenuEnabled,
    originalChannels,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getCostCenterData: (locationId) =>
    dispatch(requestsOperations.getCostCenterData(locationId)),
  getLocationUsableSkills: (locationId) =>
    dispatch(requestsOperations.getLocationUsableSkills(locationId)),
  fetchChannelMembers: (channelId) =>
    dispatch(requestsOperations.fetchChannelMembers(channelId)),
});

const PostShiftContainer = connect(mapStateToProps,mapDispatchToProps)(PostShiftComponent);

export default withRouter(PostShiftContainer);
